import React from 'react';
import {Layout, PageHeader} from '../components';
import {useNavigate, useParams} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {useEffect} from 'react';
import {getCardDetails, openModal} from '../actions';
import {useSelector} from 'react-redux';
import AddCard from './AddCard';

const CardDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {id} = useParams();
  const {cardById} = useSelector(s => s.cards);

  const onBack = () => navigate(-1);
  const onDelete = () =>
    dispatch(openModal('DeleteModal', {item: cardById, type: 'card'}));

  useEffect(() => {
    dispatch(getCardDetails(id));
  }, []);

  return (
    <Layout>
      <PageHeader onDelete={cardById && onDelete} onBack={onBack} />
      {!!cardById && <AddCard edit />}
    </Layout>
  );
};

export default CardDetails;
